import React from 'react';
import { Home, AlertTriangle } from 'lucide-react';
import { C, SourcedRow, PanelShell, Loading, Degraded, useFetch, Collapsible, LayerFooter } from './shared';

const ORDER = ['land_area_m2', 'title_type', 'floor_area_m2', 'outbuildings', 'heritage_listed', 'distance_to_coast_m', 'dwelling_type',
  'year_built', 'wall_material', 'roof_material', 'roof_condition', 'storeys', 'bedrooms', 'bathrooms', 'pool', 'solar',
  'tree_overhang', 'weekly_rent_estimate', 'short_stay_listing_detected'];

export const PropertyProfilePanel = ({ api, pid, onProfile }) => {
  const [profile, err] = useFetch(api, pid ? `/property/${encodeURIComponent(pid)}/profile` : null, [pid]);
  React.useEffect(() => { if (profile && onProfile) onProfile(profile); }, [profile]); // eslint-disable-line react-hooks/exhaustive-deps
  if (err) return <PanelShell title="Property profile" icon={<Home className="w-3 h-3" />} testid="property-profile-panel"><p className="text-[11px] py-3" style={{ color: C.red }}>{String(err)}</p></PanelShell>;
  if (!profile) return <PanelShell title="Property profile" icon={<Home className="w-3 h-3" />} testid="property-profile-panel"><Loading what="the parcel, zone, heritage and coast" /></PanelShell>;
  const populated = ORDER.filter(f => profile[f]?.confidence !== 'not_available');
  const missing = ORDER.filter(f => profile[f]?.confidence === 'not_available');
  return (
    <PanelShell title="Property profile" icon={<Home className="w-3 h-3" />} testid="property-profile-panel"
      meta={<span data-testid="property-profile-counts">{profile.counts.populated} of {profile.counts.fields} schema fields from free data · {profile.cached ? 'cached' : `${profile.elapsed_ms} ms`}</span>}>
      {profile.planning_zone && <SourcedRow name="planning zone" s={profile.planning_zone} testid="property-profile-planning_zone" />}
      {populated.map(f => <SourcedRow key={f} name={f} s={profile[f]} testid={`property-profile-${f}`} />)}
      {profile.advisories?.length > 0 && (
        <div className="mt-2 space-y-1" data-testid="property-profile-advisories">
          {profile.advisories.map(a => (
            <p key={a.code} className="text-[10px] flex items-start gap-1" style={{ color: C.amber }}>
              <AlertTriangle className="w-3 h-3 mt-0.5 shrink-0" /> <span><span className="font-mono">{a.code}</span> — {a.note}</span>
            </p>
          ))}
        </div>
      )}
      <Collapsible label="fields no open layer publishes (each names the licensed source that would)" count={missing.length} testid="property-profile-toggle-missing">
        {missing.map(f => <SourcedRow key={f} name={f} s={profile[f]} testid={`property-profile-${f}`} />)}
      </Collapsible>
      <Degraded items={profile.degraded} testid="property-profile-degraded" />
      <LayerFooter layers={profile.layers} testid="property-profile-layers" />
    </PanelShell>
  );
};
